"use client";
import React, { useEffect, useRef } from "react";
import { Github, Link } from "lucide-react";
import projects from "../data/project.json";
import { useTranslation } from "react-i18next";


function Projects() {
  const sectionRef = useRef(null);
  useEffect(() => {
    if (window.location.hash === "#contact") {
      sectionRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, []);
  const {t} = useTranslation("translation");

  return (
    <div>
            <h1 className="text-2xl font-bold mb-2 text-[var(--color-main)]">{t("header.projects")} </h1>
        <div
      ref={sectionRef}
      id="projects"
className="grid gap-6 px-4 md:px-6 py-10 grid-cols-[repeat(auto-fit,minmax(320px,1fr))]"

    >
      {projects.map((project) => (
        // <AnimatedItem key={project.id}>

        <div
          key={project.id}
          className=" w-[320px] bg-[--color-background] dark:bg-[--color-background] border border-[--color-secondary] rounded-2xl shadow-md hover:shadow-xl hover:-translate-y-2 transition duration-300 ease-in-out"
        >
          <div className="relative w-full h-48 rounded-t-2xl overflow-hidden">
            <img
              src={project.img}
              alt={project.name}
              fill
              className="object-cover"
              loading="lazy"
            />
          </div>

          <div className="p-5 flex flex-col gap-3">
            <h2 className="text-xl font-bold text-[--color-main] break-words">
              {project.name}
            </h2>

            <div className="flex gap-4 text-[--color-subtext]">
              <a
                href={project.gitHubUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[--color-highlight] transition-colors"
              >
                <Github className="w-6 h-6" />
              </a>

              {project.websiteLink === null ? (
                <a
                  href={project.websiteLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[--color-highlight] transition-colors"
                >
                  <Link className="w-6 h-6" />
                </a>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        // {/* // </AnimatedItem> */}
      ))}
    </div>
    </div>
  );
}

export default Projects;
